import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaTimes } from "react-icons/fa";
import { User, LogIn, Lock, Unlock, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSubscription } from "../components/SubscriptionContext";


const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // <-- This must be defined
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const { updateEmail } = useSubscription();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePopupClose = () => {
    setShowPopup(false);
    navigate("/");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await axios.post(
        "https://shubhjiwan.co.in/ShubhJiwan_backend11/login.php",
        formData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data.status === "success") {
        setShowPopup(true);  // Show popup on success
        const userId = response.data.user.id;
        const userEmail = response.data.user.email;

        localStorage.setItem("userId", userId);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("email", userEmail);

        updateEmail(userEmail);
      } else {
        setErrorMessage(response.data.message || "Login failed. Try again.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrorMessage("Network error. Please try again later.");
    }
  };

  return (
    <>
  <style>
        {`
          .popup-overlay {
            position: fixed;
            inset: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 50;
          }

          .popup-container {
            background-color: rgba(255, 255, 255, 0.3);
            backdrop-filter: blur(10px);
            padding: 1.5rem;
            border-radius: 1rem;
            box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.125);
            max-width: 20rem;
            animation: slide-down 0.3s ease forwards;
            text-align: center;
          }

          .popup-heading {
            font-size: 1.5rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
            color: black;
          }

          .popup-text {
            margin-bottom: 1rem;
            color: rgba(0, 0, 0, 0.8);
          }

          .popup-button {
            background-image: linear-gradient(to right, #7c3aed, #4f46e5);
            color: white;
            font-weight: 600;
            padding: 0.5rem 1rem;
            border-radius: 9999px;
            border: none;
            cursor: pointer;
            transition: background-image 0.3s ease;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }

          .popup-button:hover {
            background-image: linear-gradient(to right, #4f46e5, #7c3aed);
          }

          @keyframes slide-down {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <Navbar />
      <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-100 via-pink-50 to-purple-100">
        <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md relative transition-transform transform hover:scale-105 duration-300">
          <button
            onClick={() => navigate("/")}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition duration-300"
          >
            <FaTimes size={20} />
          </button>

          <h2 className="text-3xl text-pink-500 font-extrabold mb-6 text-center flex items-center justify-center gap-2">
            <User className="w-6 h-6" />
            Login
          </h2>

          {errorMessage && (
            <p className="text-red-500 mb-4 text-center font-medium">{errorMessage}</p>
          )}

          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label className="block text-gray-600 font-semibold">Email</label>
              <div className="flex items-center border rounded-lg shadow-sm focus-within:ring-2 focus-within:ring-blue-400 transition">
                <Mail className="w-7 h-7 text-gray-500 ml-3" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-0 focus:outline-none"
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-600 font-semibold">Password</label>
              <div className="relative flex items-center border rounded-lg shadow-sm focus-within:ring-2 focus-within:ring-blue-400 transition">
                {showPassword ? (
                  <Unlock className="w-7 h-7 text-gray-500 ml-3" />
                ) : (
                  <Lock className="w-7 h-7 text-gray-500 ml-3" />
                )}
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-0 focus:outline-none"
                  placeholder="Enter your password"
                  required
                />
                <span
                  className="absolute right-3 top-3 cursor-pointer text-gray-500 hover:text-blue-500 transition"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEyeSlash size={24} /> : <FaEye size={24} />}
                </span>
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold rounded-lg shadow-lg hover:from-purple-600 hover:to-blue-500 hover:shadow-xl transition duration-300 flex items-center justify-center gap-2"
            >
              <LogIn className="w-5 h-5" />
              Login
            </button>
          </form>

          {/* Success Popup */}
          {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h3 className="popup-heading">Login Successful</h3>
            <p className="popup-text">Welcome to ShubhJiwan! Where hearts meet and new stories begin.</p>
            <button onClick={handlePopupClose} className="popup-button">
              OK
            </button>
          </div>
        </div>
      )}

          <p className="text-center text-gray-600 mt-4">
            Don’t have an account?{" "}
            <button
              onClick={() => navigate("/create-profile")}
              className="text-blue-600 hover:underline hover:text-blue-800 transition"
            >
              Register here
            </button>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
